
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon ionic-md-settings","d":"M56.31 35.2a20.13 20.13 0 00.16-3.2c0-1.12-.16-2.08-.16-3.2l6.87-5.28a1.47 1.47 0 00.35-2.05L57 10.4a1.58 1.58 0 00-2-.64L46.82 13a23.84 23.84 0 00-5.56-3.2l-1.15-8.52A1.75 1.75 0 0038.48 0h-13.1a1.75 1.75 0 00-1.64 1.28l-1.31 8.48A27.67 27.67 0 0016.87 13L8.69 9.76a1.52 1.52 0 00-2 .64l-6.55 11a1.93 1.93 0 00.36 2.12l7 5.28c0 1.12-.16 2.08-.16 3.2s.16 2.08.16 3.2L.67 40.48a1.47 1.47 0 00-.35 2.05l6.55 11a1.59 1.59 0 002 .64L17 51a23.84 23.84 0 005.56 3.2l1.31 8.48A1.59 1.59 0 0025.53 64h13.1a1.75 1.75 0 001.63-1.28l1.31-8.48A27.75 27.75 0 0047.14 51l8.17 3.2a1.54 1.54 0 002-.64l6.54-11a1.93 1.93 0 00-.32-2.08zm-24.39 8a11.39 11.39 0 11.14 0z"}})])
          )
        }
      }
    